export const API_URL = {
    SentOtp: 'SentOtp/SentOtp',
    VerifyOTP: 'SentOtp/VerifyOTP',
    loginVerify: "LoginDetail/loginVerify",

    loginOTP: "LoginDetail/loginOTP",

    login: 'LoginDetail/login',
    SaveLoginDetail: 'LoginDetail/SaveLoginDetail',
    GetLoginDetailByUserPass: 'LoginDetail/GetLoginDetailByUserPass',
    GetLoginDetailAll: 'LoginDetail/GetLoginDetailAll',
    GetLoginDetailByMobileNo: 'LoginDetail/GetLoginDetailByMobileNo',
    GetLoginDetailById: 'LoginDetail/GetLoginDetailById',
    ForgotPassword: 'LoginDetail/ForgotPassword',
    UpdatePasswordByLoginDetailById: 'LoginDetail/UpdatePasswordByLoginDetailById',
    SaveUserImage: 'LoginDetail/SaveUserImage',

    GetProductDetailAll: 'ProductDetail/GetProductDetailAll',
    GetProductDetailById: 'ProductDetail/GetProductDetailById',
    GetProductDetail: 'ProductDetail/GetProductDetail',
    GetProductDetailAlls: 'ProductDetail/GetProductDetailAlls',
    GetProductDetailByLoginId: 'ProductDetail/GetProductDetailByLoginId',
    GetProductDetailBySubCategoryIdWithLoginId: 'ProductDetail/GetProductDetailBySubCategoryIdWithLoginId',

    SaveCancelStatus: 'ProductOrder/SaveCancelStatus',
    GetCancelType: 'CancelType/GetCancelType',
    GetProductDetailByIsHome: 'ProductDetail/GetProductDetailByIsHome',
    GetProductDetailByIsOccasion: 'ProductDetail/GetProductDetailByIsOccasion',
    SaveProductCancel: 'ProductCancel/SaveProductCancel',
    GetRetrunType: 'RetrunType/GetRetrunType',

    GetProductDetailSerach: 'ProductDetail/GetProductDetailSerach',

    GetProductCategory: 'ProductCategory/GetProductCategory',

    GetProductSubCategory: 'ProductSubCategory/GetProductSubCategory',
    GetProductSubCategoryByCategoryId: 'ProductSubCategory/GetProductSubCategoryByCategoryId',
    GetProductDetailBySubCategoryId: 'ProductDetail/GetProductDetailBySubCategoryId',

    SaveCartDetail: 'CartDetail/SaveCartDetail',
    GetCartDetailAll: 'CartDetail/GetCartDetailAll',
    GetCartDetailByLoginId: 'CartDetail/GetCartDetailByLoginId',
    DeleteCartDetailById: 'CartDetail/DeleteCartDetailById',
    DeleteCartDetailByLoginId: 'CartDetail/DeleteCartDetailByLoginId',
    SaveBulkCart: 'CartDetail/SaveBulkCart',

    SaveUserAddress: 'UserAddress/SaveUserAddress',
    GetUserAddressByLoginId: 'UserAddress/GetUserAddressByLoginId',
    GetUserAddressByLoginAddressId: 'UserAddress/GetUserAddressByLoginAddressId',

    ProductCheckout: 'Checkout/ProductCheckout',
    GetState: 'State/GetState',
    GetDistrictByStateId: 'District/GetDistrictByStateId',

    CreateOrder: 'Checkout/CreateOrder',
    SaveProductOrder: 'ProductOrder/SaveProductOrder',
    UpdatePaymentResponse: 'ProductOrder/UpdatePaymentResponse',
    GetProductOrderByLoginId: 'ProductOrder/GetProductOrderByLoginId',
    GetProductOrderByOrderId: 'ProductOrder/GetProductOrderByOrderId',

    GetCouponByIdCouponcode: 'Coupon/GetCouponByIdCouponcode',
    GetShipTracking: 'ShipmentOrder/GetShipTracking',
    GetDiscountByCouponcode: 'Coupon/GetDiscountByCouponcode',

    GetProjectPaymentGatewayByProjectId: 'ProjectPaymentGateway/GetProjectPaymentGatewayByProjectId',
    GetProjectPaymentGatewayByProjectNo: 'ProjectPaymentGateway/GetProjectPaymentGatewayByProjectNo',

    GetProductRatingByProductId: 'ProductRating/GetProductRatingByProductId',
    SaveProductRating: 'ProductRating/SaveProductRating',
    GetProductRating: 'ProductRating/GetProductRating',

    GetBlogDetail: 'BlogDetail/GetBlogDetail',
    SaveEnquiry: 'Enquiry/SaveEnquiry',

    SaveWishProduct: 'WishProduct/SaveWishProduct',
    GetWishProductByLoginId: 'WishProduct/GetWishProductByLoginId',
    DeleteWishProductByLoginProductId: 'WishProduct/DeleteWishProductByLoginProductId',
    GetProductOffer: 'ProductOffer/GetProductOffer',

    GetFaqDetail: 'FaqDetail/GetFaqDetail',

    GetBannerByBannerType: 'Banner/GetBannerByBannerType',

    GetSizeType: 'SizeType/GetSizeType',
    GetColorType: 'ColorType/GetColorType',
    GetColorTypeById: 'ColorType/GetColorTypeById',

    GetProductSkuByProductColorId: 'ProductSku/GetProductSkuByProductColorId',

    SaveCustomOrder: 'CustomOrder/SaveCustomOrder',
    GetCustomOrderByLoginId: 'CustomOrder/GetCustomOrderByLoginId',

    GetStaticPageDescriptionByStaticPageId: 'StaticPageDescription/GetStaticPageDescriptionByStaticPageId'
}